<template>
  <div class="text-right">
    <span class="text-sm">Download filtered links as:</span>
    <base-button @click="csv.download" class="mx-4" theme="gray">
      <span class="relative text-lg inline-block mr-2">
        <base-loading
          class="absolute"
          :class="{
            'opacity-0': !csv.downloading.value,
            'opacity-100': csv.downloading.value,
          }"
        />
        <icon-download
          title="Download links in CSV format"
          :class="{
            'opacity-100': !csv.downloading.value,
            'opacity-0': csv.downloading.value,
          }"
        />
      </span>
      CSV
    </base-button>
    <base-button @click="excel.download" theme="gray">
      <span class="relative text-lg inline-block mr-2">
        <base-loading
          class="absolute"
          :class="{
            'opacity-0': !excel.downloading.value,
            'opacity-100': excel.downloading.value,
          }"
        />
        <icon-download
          title="Download links in Excel file"
          :class="{
            'opacity-100': !excel.downloading.value,
            'opacity-0': excel.downloading.value,
          }"
        />
      </span>
      Excel
    </base-button>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';
import { useDownload } from '../services/useDownload';

export default {
  props: {
    filters: Object,
    userId: Number,
  },
  setup({ filters, userId }, { root }) {
    const company = computed(() => root.$store.state.company);

    return {
      csv: useDownload({ company, filters, userId, type: 'csv' }),
      excel: useDownload({
        company,
        filters,
        userId,
        type: 'excel',
      }),
    };
  },
};
</script>
